
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
// import {map, tap} from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthService {
	isLoggedIn = false;
	errMsg: string;
	authorization = '';

	// store the URL so we can redirect after logging in
	redirectUrl: string = "";
	queryParams: any = {};

	constructor ( private router: Router, private _cookieService: CookieService ) {
	}

	// Once the login is successful, save the user name and password in cookies.
	// Also, sets isLoggedIn to true.
	loginSuccessful( userName, userPassword ) {
		this.isLoggedIn = true;
		if ( userName != 'guest') {
			this._cookieService.put('NOIUserName', userName);
			this._cookieService.put('NOIUserPassword', userPassword);
		}
	}

	// Saves the authorization code for the logged in user.
	// Called from the login component.
	saveAuthorization ( Authorization ) {
		this.authorization = Authorization;
		this._cookieService.put('DWSAuthorization', Authorization);
	}

	setRedirect(redirect: string) {
		// this is terrible
		// once we change from hashLocationStrategy to PathLocationStrategy, update this!
		let path = redirect;
		let queryParams = {};

		if ( redirect.includes("?config=")) {
			queryParams = { "config": redirect.substring(path.indexOf("config=")+7)};
			path = redirect.substring(0, path.indexOf("?config"));
		}

		console.log("Setting redirect to ", path, queryParams);
		this.redirectUrl = path;
		this.queryParams = queryParams;
	}

	// Returns the authorization code for subsequent calls to user web services.
	getAuthorization() {
		return this.authorization;
	}

	// Remove the user name and password cookies, sets isLoggedIn to false, and returns
	// the user to the login screen.
	logout() {
		this.isLoggedIn = false;
		// this._cookieService.remove('NOIUserName');
		// this._cookieService.remove('NOIUserPassword');
	}

	login() {
		this.router.navigate(['/login']);
	}

}
